import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import { DrawerKey } from './drawer-types'
import drawerSlice from './drawer-slice'
import { useCallback, useMemo } from 'react'

interface UseDrawerProps {
  onOpen?: () => void
  onClose?: () => void
}

const useDrawer = (props?: UseDrawerProps) => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const drawer = useSelector((state: RootState) => state.drawer)

  const open = useCallback(
    (key: DrawerKey) => {
      dispatch(drawerSlice.actions.open(key))

      if (props?.onOpen) {
        props.onOpen()
      }
    },
    [dispatch, props],
  )

  const close = useCallback(() => {
    dispatch(drawerSlice.actions.close())

    if (props?.onClose) {
      props.onClose()
    }
  }, [dispatch, props])

  return useMemo(
    () => ({
      current: drawer,
      open,
      close,
    }),
    [open, close, drawer],
  )
}

export default useDrawer
